/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Toast_Apply_FailedInputs */

const en_keyword_optimizer_toast_apply_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Apply_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't apply this suggestion — the original text may have changed. Skip it or edit manually.`)
};

const de_keyword_optimizer_toast_apply_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Apply_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorschlag konnte nicht angewendet werden — der Originaltext wurde möglicherweise geändert. Überspringe ihn oder bearbeite manuell.`)
};

const fr_keyword_optimizer_toast_apply_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Apply_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible d'appliquer cette suggestion — le texte original a peut-être changé. Ignorez-la ou modifiez manuellement.`)
};

const es_keyword_optimizer_toast_apply_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Apply_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo aplicar esta sugerencia — el texto original puede haber cambiado. Omítela o edita manualmente.`)
};

const it_keyword_optimizer_toast_apply_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Apply_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile applicare questo suggerimento — il testo originale potrebbe essere cambiato. Saltalo o modifica manualmente.`)
};

const nl_keyword_optimizer_toast_apply_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Apply_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suggestie kon niet worden toegepast — de originele tekst is mogelijk gewijzigd. Sla deze over of pas handmatig aan.`)
};

const pl_keyword_optimizer_toast_apply_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Apply_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie można zastosować sugestii — oryginalny tekst mógł zostać zmieniony. Pomiń lub edytuj ręcznie.`)
};

const fi_keyword_optimizer_toast_apply_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Apply_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ehdotusta ei voitu soveltaa — alkuperäistä tekstiä on ehkä muutettu. Ohita tai muokkaa manuaalisesti.`)
};

const da_keyword_optimizer_toast_apply_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Apply_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forslaget kunne ikke anvendes — originalteksten er muligvis ændret. Spring over eller rediger manuelt.`)
};

const sv_keyword_optimizer_toast_apply_failed = /** @type {(inputs: Keyword_Optimizer_Toast_Apply_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förslaget kunde inte tillämpas — originaltexten kan ha ändrats. Hoppa över eller redigera manuellt.`)
};

/**
* | output |
* | --- |
* | "Couldn't apply this suggestion — the original text may have changed. Skip it or edit manually." |
*
* @param {Keyword_Optimizer_Toast_Apply_FailedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_toast_apply_failed = /** @type {((inputs?: Keyword_Optimizer_Toast_Apply_FailedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Toast_Apply_FailedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_toast_apply_failed(inputs)
	if (locale === "fr") return fr_keyword_optimizer_toast_apply_failed(inputs)
	if (locale === "es") return es_keyword_optimizer_toast_apply_failed(inputs)
	if (locale === "it") return it_keyword_optimizer_toast_apply_failed(inputs)
	if (locale === "nl") return nl_keyword_optimizer_toast_apply_failed(inputs)
	if (locale === "pl") return pl_keyword_optimizer_toast_apply_failed(inputs)
	if (locale === "fi") return fi_keyword_optimizer_toast_apply_failed(inputs)
	if (locale === "da") return da_keyword_optimizer_toast_apply_failed(inputs)
	if (locale === "sv") return sv_keyword_optimizer_toast_apply_failed(inputs)
	return en_keyword_optimizer_toast_apply_failed(inputs)
});